<div class="container-fluid">
  <h3>{{ 'common.admin' | translate | titlecase }} {{ 'common.settings' | translate | titlecase }}</h3>
  <div class="col-sm-12">
    <label>
      <input type="checkbox" [(ngModel)]="hasVerboseLogging" (ngModelChange)="verboseLoggingChanged($event)" />
      {{ 'common.enable' | translate | titlecase }} {{ 'common.detail' | translate | titlecase }}
      {{ 'common.logging' | translate | titlecase }}
    </label>
  </div>
</div>
